import { useMemo } from 'react';

import { CreatedFrom } from 'src/modules/homeownerApp/static_values';
import type { AiOrSampleDisplayImage } from 'src/modules/homeownerApp/types';

export const useFilterToCreatedFromOriginalOrStyle = (
  displayImages: AiOrSampleDisplayImage[],
  filterOutOriginal = false,
) => {
  const filters: string[] = useMemo(
    () =>
      filterOutOriginal
        ? [CreatedFrom.STYLE]
        : [CreatedFrom.ORIGINAL, CreatedFrom.STYLE],
    [filterOutOriginal],
  );
  return useMemo(
    () =>
      displayImages.filter(displayImage =>
        filters.includes(displayImage.createdFrom),
      ),
    [displayImages, filters],
  );
};
